<div class="container">
    <div class="row">
        <div class="col-sm-7 col-md-8 col-lg-8 col-xl-8 selenium-browse-by-subject">
            <div class="browse-title">Browse by Subject</div>
            <app-button
                *ngFor="let node of chNodes"
                id="selenium-homepage-chn-{{ node.id }}"
                [routerLink]="node.getBrowseURL()"
                [class]="gtmBrowseBySubject"
                [gtmLabel]="node.title"
                >{{ node.title }}</app-button
            >
        </div>
        <div class="col-sm-5 col-md-4 col-lg-4 col-xl-4 selenium-browse-by-grades">
            <div class="browse-title">Browse by Grade</div>
            <app-button
                *ngFor="let grade of grades"
                id="selenium-homepage-grade-{{ grade.slug }}"
                [routerLink]="['grades', grade.slug]"
                [class]="gtmBrowseByGrade"
                [gtmLabel]="grade.title"
                >{{ grade.title }}</app-button
            >
        </div>
    </div>
</div>
